<template>

    <header class="topbar">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">

        <router-link class="navbar-brand" to="/"><ico class="logo" ico="logo" size="30" /> Theme Deploy</router-link>
        <ul class="ml-auto navbar-nav" >
		  <router-link v-if="user.is_business_admin" class="nav-link is-desktop" href="#" to="/users">{{ _lang('Users') }}</router-link>
          <router-link v-if="user.is_business_admin" class="nav-link is-desktop" href="#" to="/user">{{user.email}}</router-link>
		  <li v-if="!user.is_business_admin" class="nav-link is-desktop">{{user.email}}</li>
          <router-link class="nav-link is-mobile" href="#" to="/user">
            <span class="icosvg">
              <svg viewBox="0 0 24 24" class="icosvg">
                <path fill="currentColor" d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" />
              </svg>
            </span>
          </router-link>
          <router-link class="nav-link" href="#" to="/logout">Logout</router-link>
        </ul>
      </nav>
    </header>

</template>

<style scoped>

.logo {
 display:inline-block;
 transition: .3s;
 }
 .navbar-brand { display:inline-flex; align-items: center;}
  .navbar-brand:hover .logo { transform:scale(1.1);  }
@media(max-width:991px){
    .icosvg { margin-right:10px;}
    .navbar-nav {
        flex-direction:row;
    }
    .navbar-brand{
        padding:0;
        font-size:16px;
    }
}

</style>
<script>

import Ico from './Ico';

export default {
    name: 'app-header',
		components:{
			Ico
		},
    computed:{
        user(){
            return this.$store.getters.user;
        }
    },

}
</script>
